import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { ProfilePageLayout } from '../../ProfilePageLayout';
import {
  BusinessDetailsForm,
  useBusinessDetailsSetupForm,
} from './BusinessDetailsForm';
import { BusinessDetailsInfo } from './BusinessDetailsInfo';

export function BusinessDetailsPage() {
  const { formik, isFetching, isMoovAvailable, isSubmitDisabled } =
    useBusinessDetailsSetupForm();

  return (
    <ProfilePageLayout
      title="Setup SuperPay"
      formik={formik}
      isLoading={formik.isSubmitting || isFetching}
      actions={false}
    >
      <Box
        aria-label="business details container"
        maxWidth={['initial', 'initial', '528px']}
        margin="auto"
        padding="small"
      >
        <Stack space="small">
          <BusinessDetailsInfo isMoovAvailable={isMoovAvailable} />
          <Box
            borderColor="Silver400"
            borderWidth="small"
            borderRadius="small"
            padding="small"
          >
            <Stack space="large">
              <Stack space="small">
                <Typography variant="h3">Business Details</Typography>
                <BusinessDetailsForm disabled={!isMoovAvailable} />
              </Stack>
              <Button
                onClick={() => {
                  void formik.submitForm();
                }}
                pending={formik.isSubmitting}
                disabled={isSubmitDisabled}
              >
                Continue
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </ProfilePageLayout>
  );
}
